import { motion } from 'framer-motion'

const SvgComponent = ({ transition, ...props }) => (
  <motion.svg
    initial={{
      y: '30%',
      x: '-10%',
      scale: 0.75,
      opacity: 0
    }}
    animate={{
      y: '5%',
      opacity: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}

    viewBox="0 0 259 322"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.6} filter="url(#horv2by1sa)">
      <circle
        cx={100.215}
        cy={221.046}
        r={81.688}
        transform="rotate(165 100.215 221.046)"
        fill="url(#xi0xjj3zcb)"
      />
    </g>
    <g opacity={0.6} filter="url(#7wij7tzroc)">
      <circle
        cx={173.068}
        cy={112.899}
        r={25.229}
        transform="rotate(165 173.068 112.899)"
        fill="url(#eanvu6q0hd)"
      />
    </g>
    <g opacity={0.6} filter="url(#0q2jrzzyre)">
      <circle
        cx={76.795}
        cy={51.626}
        r={20.107}
        transform="rotate(165 76.795 51.626)"
        fill="url(#rxylyzz7xf)"
      />
    </g>
    <path
      d="M192.4 179.592c11.369 2.085 24.11 1.588 37.099-1.883l-6.665-7.023a92.721 92.721 0 0 0 20.471-28.534 91.692 91.692 0 0 0 8.299-34.138l-19.004-.857a72.691 72.691 0 0 1-6.584 27.065 73.596 73.596 0 0 1-16.269 22.674l-6.665-7.024c-.954 9.69-4.402 20.063-10.686 29.712l.004.008z"
      fill="url(#kqngny7xog)"
    />
    <path
      d="M97.373 158.548c1.576 11.402 5.89 23.39 13.199 34.673l4.642-8.494a91.818 91.818 0 0 0 33.535 10.611 93.543 93.543 0 0 0 35.041-2.686l-5.009-18.324c-9.026 2.455-18.572 3.198-27.858 2.139a72.876 72.876 0 0 1-26.594-8.414l4.642-8.493c-9.534 2.074-20.432 1.923-31.602-1.008l.004-.004z"
      fill="url(#irihdonwrh)"
    />
    <path
      d="M88.065 61.808C77.645 66.79 67.59 74.623 59.124 85.09l9.526 1.768c-2.17 11.595-2.058 23.562.233 35.098a91.855 91.855 0 0 0 13.385 32.485l15.886-10.456a72.753 72.753 0 0 1-10.615-25.761c-1.82-9.188-1.902-18.72-.186-27.894l9.526 1.769C91.931 83.725 88.66 73.3 88.068 61.8l-.003.008z"
      fill="url(#nrg9l59oti)"
    />
    <path
      d="M177.336 23.03c-7.971-8.28-18.582-15.49-31.096-20.25l1.247 9.594c-11.678 1.505-23.103 5.274-33.378 11.071a92.438 92.438 0 0 0-26.778 22.754l14.854 11.866a73.44 73.44 0 0 1 21.267-18.073c8.15-4.596 17.18-7.577 26.482-8.78l1.247 9.595c6.525-7.346 15.383-13.576 26.159-17.777h-.004z"
      fill="url(#6oehel3ntj)"
    />
    <path
      d="M241.82 95.831c5.412-10.134 9.031-22.375 9.724-35.823l-8.75 4.154c-5.065-10.645-12.211-20.283-20.888-28.243a92.632 92.632 0 0 0-29.918-18.425l-6.727 17.77A73.52 73.52 0 0 1 209.029 49.9a73.277 73.277 0 0 1 16.586 22.42l-8.753 4.154c8.935 3.882 17.629 10.41 24.961 19.349l-.003.008z"
      fill="url(#884a6zc2qk)"
    />
    <g filter="url(#zxhgb1gdel)">
      <path
        d="M128.847 76.443a39.508 39.508 0 0 1 8.023-6.782l-.842-9.703 15.349-4.906 4.939 8.392a39.473 39.473 0 0 1 10.467.872l6.263-7.454 14.32 7.386-2.438 9.422a39.628 39.628 0 0 1 6.782 8.024l9.703-.842 4.906 15.348-8.392 4.943a39.478 39.478 0 0 1-.871 10.467l7.453 6.263-7.382 14.32-9.422-2.438a39.386 39.386 0 0 1-8.024 6.778l.842 9.703-15.348 4.906-4.943-8.392a39.478 39.478 0 0 1-10.467-.871l-6.263 7.453-14.321-7.386 2.439-9.422a39.507 39.507 0 0 1-6.783-8.023l-9.702.842-4.906-15.349 8.391-4.943c-.174-3.473.106-6.99.872-10.466l-7.454-6.264 7.386-14.32 9.426 2.438-.003.004zm10.46 16.88c-5.399 10.475-1.289 23.345 9.185 28.745 10.475 5.4 23.345 1.286 28.745-9.189 5.4-10.475 1.29-23.345-9.185-28.745-10.475-5.4-23.345-1.286-28.745 9.185v.004z"
        fill="url(#70yi5arnam)"
      />
    </g>
    <defs>
      <linearGradient
        id="xi0xjj3zcb"
        x1={193.816}
        y1={248.275}
        x2={10.003}
        y2={248.169}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="eanvu6q0hd"
        x1={201.976}
        y1={121.308}
        x2={145.206}
        y2={121.275}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="rxylyzz7xf"
        x1={99.834}
        y1={58.329}
        x2={54.589}
        y2={58.303}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="kqngny7xog"
        x1={228.612}
        y1={112.499}
        x2={217.182}
        y2={170.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="irihdonwrh"
        x1={188.534}
        y1={178.954}
        x2={95.843}
        y2={187.77}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="nrg9l59oti"
        x1={81.497}
        y1={68.814}
        x2={49.845}
        y2={125.9}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="6oehel3ntj"
        x1={143.072}
        y1={6.622}
        x2={140.639}
        y2={49.956}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="884a6zc2qk"
        x1={256.845}
        y1={66.675}
        x2={185.606}
        y2={73.498}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="70yi5arnam"
        x1={72.252}
        y1={123.552}
        x2={335.763}
        y2={66.865}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <filter
        id="horv2by1sa"
        x={14.508}
        y={135.339}
        width={171.415}
        height={171.416}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10271"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10271"
          result="shape"
        />
      </filter>
      <filter
        id="7wij7tzroc"
        x={143.833}
        y={83.664}
        width={58.47}
        height={58.47}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10271"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10271"
          result="shape"
        />
      </filter>
      <filter
        id="0q2jrzzyre"
        x={52.683}
        y={27.514}
        width={48.225}
        height={48.224}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10271"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10271"
          result="shape"
        />
      </filter>
      <filter
        id="zxhgb1gdel"
        x={85.228}
        y={30.052}
        width={146.09}
        height={146.089}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={12.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10271"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10271"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
